import { Platform } from '../types';
import { defaultLocale } from './i18next';

// eslint-disable-next-line
const sampleProductList = require('./fixtures.json');

export const mockAzarJs = {
  getLoginResponseJson: () => '',
  getPlatform: () => Platform.ANDROID,
  getUiLocale: () => defaultLocale,
  getProductPriceInfoListJson: () => {
    const products = sampleProductList.productList;
    return JSON.stringify(products);
  },
  startPurchase: (productId: string) => {
    console.log(`startPurchase: ${productId}`);
    setTimeout(() => {
      window.purchaseFinished(productId, true);
    }, 2000);
  },
  startPurchaseV2: (productId: string, type: string) => {
    console.log(`startPurchaseV2: ${productId}`, `type: ${type}`);
    setTimeout(() => {
      window.purchaseFinished(productId, true);
    }, 2000);
  },
  closePopup: () => console.log('close popup'),
  reload: () => console.log('reload'),
  startPurchaseInAppMarket: () => console.log('startPurchaseInAppMarket'),
  handlePgPurchaseResult: (orderId: string, productId: string, errorCode: string) =>
    console.log(orderId, productId, errorCode),
  setNavigation: (isVisible: string) => console.log(`${isVisible === 'true' ? 'show' : 'hide'} navigation`),
};
